/* tslint:disable:max-line-length */
import React from 'react';
import classNames from 'classnames';
import { IconTypeProps } from '../types';

export const TrashIcon = ({
  className,
  style,
  color = '#FF344A',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M16.5048 2.59046H12.7598V1.97985C12.7598 0.888158 11.8716 0 10.7799 0H7.21987C6.12817 0 5.24002 0.888158 5.24002 1.97985V2.59046H1.49495C1.2174 2.59046 0.995361 2.8125 0.995361 3.09005C0.995361 3.3676 1.2174 3.58964 1.49495 3.58964H2.39791V15.3281C2.39791 16.801 3.59692 18 5.06979 18H12.93C14.4028 18 15.6019 16.801 15.6019 15.3281V3.58964H16.5048C16.7824 3.58964 17.0044 3.3676 17.0044 3.09005C17.0044 2.8125 16.7824 2.59046 16.5048 2.59046ZM6.23919 1.97985C6.23919 1.43956 6.67957 0.999178 7.21987 0.999178H10.7799C11.3202 0.999178 11.7606 1.43956 11.7606 1.97985V2.59046H6.23919V1.97985ZM14.6027 15.3281C14.6027 16.2496 13.8514 17.0008 12.93 17.0008H5.06979C4.14832 17.0008 3.39709 16.2496 3.39709 15.3281V3.58964H14.6064V15.3281H14.6027Z"
        fill={color}
      />
      <path
        d="M8.99983 15.2097C9.27738 15.2097 9.49942 14.9877 9.49942 14.7101V5.88036C9.49942 5.60281 9.27738 5.38077 8.99983 5.38077C8.72228 5.38077 8.50024 5.60281 8.50024 5.88036V14.7064C8.50024 14.984 8.72228 15.2097 8.99983 15.2097Z"
        fill={color}
      />
      <path
        d="M5.73958 14.6583C6.01713 14.6583 6.23917 14.4363 6.23917 14.1587V6.42806C6.23917 6.15051 6.01713 5.92847 5.73958 5.92847C5.46203 5.92847 5.23999 6.15051 5.23999 6.42806V14.1587C5.23999 14.4363 5.46573 14.6583 5.73958 14.6583Z"
        fill={color}
      />
      <path
        d="M12.2601 14.6583C12.5376 14.6583 12.7597 14.4363 12.7597 14.1587V6.42806C12.7597 6.15051 12.5376 5.92847 12.2601 5.92847C11.9825 5.92847 11.7605 6.15051 11.7605 6.42806V14.1587C11.7605 14.4363 11.9825 14.6583 12.2601 14.6583Z"
        fill={color}
      />
    </svg>
  );
};
